import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, FormHelperText, Typography } from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";

export default function CommunicationPreferences({ open, handleClose }) {
  const [whatsappOptIn, setWhatsappOptIn] = useState(false);
  const [emailOptIn, setEmailOptIn] = useState(false);
  const [smsOptIn, setSmsOptIn] = useState(false);
  const [error, setError] = useState(""); // State to handle error message
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(localStorage.getItem("user"));
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  // Fetch existing communication preferences when the modal is opened
  useEffect(() => {
    if (open) {
      const fetchCommunicationPreferences = async () => {
        try {
          const response = await axios.post(
            `${backendUrl}/api/user/get-communication-preferences`,
            { uuid: user.uuid },
            {
              headers: { "x-api-key": process.env.REACT_APP_BACKEND_API_KEY },
            }
          );
          const { whatsappOptIn, emailOptIn, smsOptIn } = response.data;
          setWhatsappOptIn(whatsappOptIn); // Set the state based on the response
          setEmailOptIn(emailOptIn);
          setSmsOptIn(smsOptIn);
        } catch (error) {
          console.error("Error fetching communication preferences:", error);
          enqueueSnackbar("Failed to fetch communication preferences.", { variant: "error" });
        }
      };

      fetchCommunicationPreferences();
    }
  }, [open, user.uuid, enqueueSnackbar, backendUrl]);

  // Handle communication preference form submission
  const handleSave = async () => {
    // Enforce that at least one of WhatsApp or Email is selected
    if (!whatsappOptIn && !emailOptIn) {
      setError("Please select at least one communication preference between WhatsApp or Email.");
      return;
    } else {
      setError(""); // Clear the error message if valid
    }

    try {
      const response = await axios.post(`${backendUrl}/api/user/communication-preferences`, {
        userUuid: user.uuid,
        whatsappOptIn,
        emailOptIn,
        smsOptIn,
      }, {
        headers: { "x-api-key": process.env.REACT_APP_BACKEND_API_KEY },
      });
      enqueueSnackbar(response.data.message, { variant: "success" });
      handleClose(); // Close the modal on success
    } catch (error) {
      console.error("Error updating preferences:", error);
      enqueueSnackbar("Failed to update communication preferences.", { variant: "error" });
    }
  };

  const handleWhatsappChange = (event) => setWhatsappOptIn(event.target.checked);
  const handleEmailChange = (event) => setEmailOptIn(event.target.checked);
  const handleSmsChange = (event) => setSmsOptIn(event.target.checked);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Communication Preferences</DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          Manage your communication preferences below. Choose the methods through which you'd like to receive updates from us:
        </Typography>
        
        {/* Error Alert */}
        {error && (
          <FormHelperText error>{error}</FormHelperText>
        )}

        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={whatsappOptIn} onChange={handleWhatsappChange} />}
            label="WhatsApp"
          />
          <FormControlLabel
            control={<Checkbox checked={emailOptIn} onChange={handleEmailChange} />}
            label="Email"
          />
          <FormControlLabel
            control={<Checkbox checked={smsOptIn} onChange={handleSmsChange} />}
            label="SMS"
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
